import React from 'react';
import PropTypes from "prop-types";
export var useEuiTextDiffProp = () => {
  return <div />;
};
useEuiTextDiffProp.propTypes = {
  className: PropTypes.string,
  "aria-label": PropTypes.string,
  "data-test-subj": PropTypes.string,
  css: PropTypes.any,
  /**
     * The starting string
     */
  beforeText: PropTypes.string.isRequired,
  /**
     * The string used to compare against `beforeText`
     */
  afterText: PropTypes.string.isRequired,
  /**
     * HTML element to wrap insertion differences.
     * Defaults to `ins`
     */
  insertComponent: PropTypes.any,
  /**
     * HTML element to wrap deletion differences.
     * Defaults to `del`
     */
  deleteComponent: PropTypes.any,
  /**
     * HTML element to wrap text with no differences.
     * Doesn't wrap with anything by default
     */
  sameComponent: PropTypes.any,
  /**
     * Time in milliseconds. Passing a timeout of value '0' disables the timeout state
     */
  timeout: PropTypes.number
};
try {
  useEuiTextDiffProp.__docgenInfo = {
    tags: {},
    filePath: '/app/packages/eui/src-docs/src/views/text_diff/props.tsx',
    description: '',
    displayName: 'useEuiTextDiffProp',
    methods: [],
    props: {
      className: {
        defaultValue: null,
        description: '',
        name: 'className',
        parent: {
          fileName: 'eui/src/components/common.ts',
          name: 'CommonProps'
        },
        declarations: [{
          fileName: 'eui/src/components/common.ts',
          name: 'CommonProps'
        }, {
          fileName: 'eui/node_modules/@types/react/ts5.0/index.d.ts',
          name: 'HTMLAttributes'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      'aria-label': {
        defaultValue: null,
        description: 'Defines a string value that labels the current element.\n' + '@see aria-labelledby.',
        name: 'aria-label',
        parent: {
          fileName: 'eui/src/components/common.ts',
          name: 'CommonProps'
        },
        declarations: [{
          fileName: 'eui/src/components/common.ts',
          name: 'CommonProps'
        }, {
          fileName: 'eui/node_modules/@types/react/ts5.0/index.d.ts',
          name: 'AriaAttributes'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      'data-test-subj': {
        defaultValue: null,
        description: '',
        name: 'data-test-subj',
        parent: {
          fileName: 'eui/src/components/common.ts',
          name: 'CommonProps'
        },
        declarations: [{
          fileName: 'eui/src/components/common.ts',
          name: 'CommonProps'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      css: {
        defaultValue: null,
        description: '',
        name: 'css',
        parent: {
          fileName: 'eui/src/components/common.ts',
          name: 'CommonProps'
        },
        declarations: [{
          fileName: 'eui/src/components/common.ts',
          name: 'CommonProps'
        }],
        required: false,
        type: {
          name: 'Interpolation<Theme>'
        }
      },
      beforeText: {
        defaultValue: null,
        description: 'The starting string',
        name: 'beforeText',
        parent: {
          fileName: 'eui/src/components/text_diff/text_diff.tsx',
          name: 'Props'
        },
        declarations: [{
          fileName: 'eui/src/components/text_diff/text_diff.tsx',
          name: 'Props'
        }],
        required: true,
        type: {
          name: 'string'
        }
      },
      afterText: {
        defaultValue: null,
        description: 'The string used to compare against `beforeText`',
        name: 'afterText',
        parent: {
          fileName: 'eui/src/components/text_diff/text_diff.tsx',
          name: 'Props'
        },
        declarations: [{
          fileName: 'eui/src/components/text_diff/text_diff.tsx',
          name: 'Props'
        }],
        required: true,
        type: {
          name: 'string'
        }
      },
      insertComponent: {
        defaultValue: null,
        description: 'HTML element to wrap insertion differences.\nDefaults to `ins`',
        name: 'insertComponent',
        parent: {
          fileName: 'eui/src/components/text_diff/text_diff.tsx',
          name: 'Props'
        },
        declarations: [{
          fileName: 'eui/src/components/text_diff/text_diff.tsx',
          name: 'Props'
        }],
        required: false,
        type: {
          name: 'ElementType<any, keyof IntrinsicElements>'
        }
      },
      deleteComponent: {
        defaultValue: null,
        description: 'HTML element to wrap deletion differences.\nDefaults to `del`',
        name: 'deleteComponent',
        parent: {
          fileName: 'eui/src/components/text_diff/text_diff.tsx',
          name: 'Props'
        },
        declarations: [{
          fileName: 'eui/src/components/text_diff/text_diff.tsx',
          name: 'Props'
        }],
        required: false,
        type: {
          name: 'ElementType<any, keyof IntrinsicElements>'
        }
      },
      sameComponent: {
        defaultValue: null,
        description: 'HTML element to wrap text with no differences.\n' + "Doesn't wrap with anything by default",
        name: 'sameComponent',
        parent: {
          fileName: 'eui/src/components/text_diff/text_diff.tsx',
          name: 'Props'
        },
        declarations: [{
          fileName: 'eui/src/components/text_diff/text_diff.tsx',
          name: 'Props'
        }],
        required: false,
        type: {
          name: 'ElementType<any, keyof IntrinsicElements>'
        }
      },
      timeout: {
        defaultValue: null,
        description: "Time in milliseconds. Passing a timeout of value '0' disables the timeout state",
        name: 'timeout',
        parent: {
          fileName: 'eui/src/components/text_diff/text_diff.tsx',
          name: 'Props'
        },
        declarations: [{
          fileName: 'eui/src/components/text_diff/text_diff.tsx',
          name: 'Props'
        }],
        required: false,
        type: {
          name: 'number'
        }
      }
    },
    extendedInterfaces: ['CommonProps', 'Props', 'HTMLAttributes', 'AriaAttributes', 'DOMAttributes']
  };
} catch (e) {}